/**
 * 
 * @mainSection: Calculators;
 * @dateCreated: 20190313;
 * @by : lakmal@fortunaglobal.com;
 *
 */


var pmt = function(rate_per_period, number_of_payments, present_value, future_value, type){
    if(rate_per_period != 0.0){
        // Interest rate exists
        var q = Math.pow(1 + rate_per_period, number_of_payments);
        return -(rate_per_period * (future_value + (q * present_value))) / ((-1 + q) * (1 + rate_per_period * (type)));

    } else if(number_of_payments != 0.0){
        // No interest rate, but number of payments exists
        return -(future_value + present_value) / number_of_payments;
    }

    return 0;
};

$.validator.addMethod("maxValue", function (value, element, params) {
    if(commaSeparateRemove(value) > params){
        return false;
    } else{
        return true;
    }
}, function(params, element){
    var maxValue = commaSeparatedNumber(params);
    var msg = "Please enter a  value less than "+ maxValue;
    return $.validator.format(msg);
});


$.validator.addMethod("minValue", function (value, element, params) {
    if(commaSeparateRemove(value) < params){
        return false;
    } else{
        return true;
    }
}, function(params, element){
    var minValue = commaSeparatedNumber(params);
    var msg = "Please enter a  value more than "+ minValue;
    return $.validator.format(msg);
});


// Common scripts
(function($) {

    $('[data-toggle="tooltip"]').tooltip({
        //trigger: 'click'
    });

    // Mast Functions
    //$('.money').mask("#,##0.00", { reverse: true });
    $('.money').mask("#,##0", { reverse: true });
    //$('.percent').mask('##0.00', { reverse: true });

    // Click Plus Button
    $(document).on('click', '.btn-plus', function(e) {
        e.preventDefault();
        var currentValue = $(this).closest('.input-group').find('input').val();
        if (currentValue) {
            currentValue = parseInt(currentValue);
        } else {
            currentValue = 0;
        }
        var newValue = currentValue + 1;
        $(this).closest('.input-group').find('input').val(newValue);
        $(this).closest('.input-group').find('input').valid(0);
    });

    // Click Minus Button
    $(document).on('click', '.btn-minus', function(e) {
        e.preventDefault();
        var currentValue = $(this).closest('.input-group').find('input').val();
        if (currentValue) {
            currentValue = parseInt(currentValue);
        } else {
            currentValue = 0;
        }
        var newValue = currentValue - 1;
        $(this).closest('.input-group').find('input').val(newValue);
        $(this).closest('.input-group').find('input').valid(0);
    });

    $(document).on('click', '.btn-print', function(e) {
        e.preventDefault();
        var $form = $(this).closest('form');
        if ($form.valid()) {
            $form.submit();
            // $(".calc-print:hidden").printThis({});
            // $(".calc-tnc-inner").append($(".calc-print:hidden"));
         $(".calc-print:hidden").printThis({
              importCSS: false,
              importStyle: false,
              printDelay: 5000,
              removeScripts: true
         });
        }
    });

}(jQuery));


/*
 * 
 * Personal Loan Calculator
 *
 */ 
(function($) {

    // Calculator Validations
    var validator = $('#personal-loan-calc-form').validate({
        ignore: [],
        rules: {
            loan_value: {
                required: true,
                maxlength: 100
            },
            loan_term: {
                required: true,
                min: 1,
                max: 10,
                maxlength: 2
            },
            interest_rate: {
                required: true,
                percentage: true,
                maxlength: 5
            },
            // comparison_rate: {
            //     required: true,
            //     maxlength: 5
            // },
            // location: {
            //     required: true,
            // }
        },
        // messages: {},
        errorPlacement: function(error, element) {
            if (element.parent().hasClass('input-group')) {
                element.closest('.input-group').after(error);
            } else if (element.attr('type') === 'checkbox') {
                element.closest('.checkbox').append(error);
            } else {
                error.insertAfter(element);
            }
        },
    });

    // Calculate Function
    var calculate = function(formData) {
        
        //console.log(formData);

        var interest1stMonth = formData.loan_value * (formData.interest_rate / 100) / 12; 

        //pmt = function(rate_per_period, number_of_payments, present_value, future_value, type){
        var pmtValue = pmt(((formData.interest_rate/100) / 12), (formData.loan_term * 12), formData.loan_value, 0, 0);
        
        var rental = Math.abs(pmtValue);
        var capitalPayment1stMonth = rental - interest1stMonth;

        $('#installment').val(commaSeparatedNumber(rental.toFixed(2)));
        $('.installment_text').text(commaSeparatedNumber(rental.toFixed(2)));

        $('.load_amount_text').text(commaSeparatedNumber(formData.loan_value.toFixed(2)));
        $('.loan_term_text').text(commaSeparatedNumber(formData.loan_term));
        $('.interest_rate_text').text(commaSeparatedNumber(formData.interest_rate));

        $('.capital_payment_text').text(commaSeparatedNumber(capitalPayment1stMonth.toFixed(2)));
        $('.interest_payment_text').text(commaSeparatedNumber(interest1stMonth.toFixed(2)));

    };

    // Click Reset Button
    $(document).on('click', '#personal-loan-calc-form .btn-reset', function() {
        validator.resetForm();
        $('#installment').val('0.00');
        $('.installment_text').text(0);
        $('.loan_term_text').text(0); 
        $('.interest_rate_text').text(0);
        //$('.comparison_rate_text').text(0);
        $('.capital_payment_text').text('0.00');
        $('.interest_payment_text').text('0.00');
    });

    // Click Calculate Button
    $('#personal-loan-calc-form').on('submit', function(e) {
        e.preventDefault();
        if ($(this).valid()) {
            var formData = [];
            //formData['loan_value'] = parseFloat(($('#loan_value').cleanVal() / 100).toFixed(2));
            formData['loan_value'] = parseFloat($('#loan_value').cleanVal());
            formData['loan_term'] = parseInt($('#loan_term').val());
            formData['interest_rate'] = parseFloat($('#interest_rate').val());
            calculate(formData);

        }
    });


}(jQuery));



/*
 * 
 * Lease Calculator
 *
 */
(function($) {

    // Calculator Validations
    var validator = $('#lease-calc-form').validate({
        ignore: [],
        rules: {
            loan_value: {
                required: true,
                maxlength: 100
            },
            loan_term: {
                required: true,
            },
            interest_rate: {
                required: true,
                percentage: true,
                maxlength: 5
            },
            down_payment: {
                required: true,
                maxlength: 100
            },
        },
        // messages: {},
        errorPlacement: function(error, element) {
            if (element.parent().hasClass('input-group')) {
                element.closest('.input-group').after(error);
            } else if (element.attr('type') === 'checkbox') {
                element.closest('.checkbox').append(error);
            } else {
                error.insertAfter(element);
            }
        },
    });

    // Calculate Function
    var calculate = function(formData) {
        //console.log(formData);
        var calcVar1 = formData.down_payment - formData.loan_term;
        var calcVar2 = (formData.interest_rate / 12) / 100; 

        // //E3/(E6+((1-((1+K3)^K4))/K3))
        var rental = formData.loan_value / (formData.down_payment + ((1 - (Math.pow((1 + calcVar2), calcVar1))) / calcVar2));

        $('#installment').val(commaSeparatedNumber(rental.toFixed(2)));
        $('.installment_text').text(commaSeparatedNumber(rental.toFixed(2)));

        $('.load_amount_text').text(commaSeparatedNumber(formData.loan_value.toFixed(2)));
        $('.loan_term_text').text(commaSeparatedNumber(formData.loan_term));
        $('.interest_rate_text').text(commaSeparatedNumber(formData.interest_rate));
        $('.down_payment_text').text(commaSeparatedNumber(formData.down_payment));

        $('.calc-results').collapse('show');  

    };

    // Click Reset Button
    $(document).on('click', '#lease-calc-form .btn-reset', function() {
        validator.resetForm();
        $('#installment').val('0.00');
        $('.installment_text').text(0);
        $('.loan_term_text').text(0);
        $('.interest_rate_text').text(0);
        $('.down_payment_text').text(0);

        $('.calc-results').collapse('hide');
    });

    // Click Calculate Button
    $('#lease-calc-form').on('submit', function(e) {
        e.preventDefault(); 
        if ($(this).valid()) {
            var formData = [];
            //formData['loan_value'] = parseFloat(($('#loan_value').cleanVal() / 100).toFixed(2));
            formData['loan_value'] = parseFloat($('#loan_value').cleanVal());
            formData['loan_term'] = parseInt($('#loan_term').val());
            formData['interest_rate'] = parseFloat($('#interest_rate').val());
            formData['down_payment'] = parseInt($('#down_payment').val());
            calculate(formData);
        }
    });


}(jQuery));



/*
 * 
 * Fixed Deposit Calculator
 *
 */
(function($) {

    // Calculator Validations
    var validator = $('#fixed-deposit-calc-form').validate({
        ignore: [],
        rules: {
            initial_deposits: {
                required: true,
                maxlength: 100
            },
            interest_rate: {
                required: true,
                percentage: true,
                maxlength: 5
            },
            maturity_period: {
                required: true,
            },
        },
        // messages: {},
        errorPlacement: function(error, element) {
            if (element.parent().hasClass('input-group')) {
                element.closest('.input-group').after(error);
            } else if (element.attr('type') === 'checkbox') {
                element.closest('.checkbox').append(error);
            } else {
                error.insertAfter(element);
            }
        },
    });

    // Calculate Function
    var calculate = function(formData) {

        //console.log(formData);  

        var interestEarned = (formData.initial_deposit * (formData.interest_rate / 100) / 12) * formData.maturity_period;
        var taxAmount = interestEarned * formData.tax_rate / 100;
        var interestAfterTax = interestEarned - taxAmount;
        var totalValue = formData.initial_deposit + interestAfterTax;

        $('#total_value').val(commaSeparatedNumber(totalValue.toFixed(2)));      
        $('.total_value_text').text(commaSeparatedNumber(totalValue.toFixed(2)));

        $('.initial_deposit_text').text(commaSeparatedNumber(formData.initial_deposit.toFixed(2))); 
        $('.maturity_period_text').text(commaSeparatedNumber(formData.maturity_period)); 
        $('.interest_rate_text').text(commaSeparatedNumber(formData.interest_rate));

        $('.interest_earned_text').text(commaSeparatedNumber(interestEarned.toFixed(2)));
        $('.tax_rate_text').text(formData.tax_rate.toFixed(2));
        $('.tax_amount_text').text(commaSeparatedNumber(taxAmount.toFixed(2)));
        $('.interest_after_tax_text').text(commaSeparatedNumber(interestAfterTax.toFixed(2)));

    };

    // Click Reset Button
    $(document).on('click', '#fixed-deposit-calc-form .btn-reset', function() {
        validator.resetForm();
        $('#installment').val('0.00');
        $('.installment_text').text(0);
        $('.loan_term_text').text(0);
        $('.interest_rate_text').text(0);

        $('.interest_earned_text').text('0.00');
        $('.tax_rate_text').text('0.00');
        $('.tax_amount_text').text(0);
        $('.interest_earned_text').text('0.00');
        $('#total_value').val('0.00');
        $('.interest_after_tax_text').text('0.00');

    });

    // Click Calculate Button
    $('#fixed-deposit-calc-form').on('submit', function(e) {
        e.preventDefault();
        if ($(this).valid()) {
            var formData = [];
            //formData['initial_deposit'] = parseFloat(($('#initial_deposit').cleanVal() / 100).toFixed(2));
            formData['initial_deposit'] = parseFloat($('#initial_deposit').cleanVal());
            formData['interest_rate'] = parseFloat($('#interest_rate').val());
            formData['maturity_period'] = parseInt($('#maturity_period').val());
            formData['tax_rate'] = parseFloat($('#tax_rate').val());
            calculate(formData);
        }
    });

}(jQuery));



/*
 * 
 * Home Loan Calculator
 *
 */
(function($) {

    // Calculator Validations
    var validator = $('#home-loan-calc-form').validate({
        ignore: [],
        rules: {
            loan_value: {
                required: true,
                //maxlength: 7, 
                //maxValue: 500000, 
                minValue: 50000, 
            },
            // loan_term: {
            //     required: true,
            //     number: true,
            //     min: 1,
            //     max: 2100,
            //     maxlength: 4
            // },
            loan_term_years: {
                required: true,
            },
            loan_term_months: {
                required: true,
            },
            interest_rate: {
                required: true,
                percentage: true,
                maxlength: 5
            },
            repayment_method: {
                required: true,
            },
        },
        // messages: {},
        errorPlacement: function(error, element) {
            if (element.parent().hasClass('input-group')) {
                element.closest('.input-group').after(error);
            } else if (element.attr('type') === 'checkbox') {
                element.closest('.checkbox').append(error);
            } else {
                error.insertAfter(element);
            }
        },
    });

    // Calculate Function
    var calculate = function(formData) {
        
        //console.log(formData);
        var interest1stMonth = formData.loan_value * (formData.interest_rate / 100) / 12;
        var rental = 0; 
        var capitalPayment1stMonth = 0; 
        var loanTerm = (formData.loan_term_years * 12) + formData.loan_term_months;

        if(formData.repayment_method === 'Reducing Balance'){
            capitalPayment1stMonth = formData.loan_value / loanTerm;
            rental = interest1stMonth + capitalPayment1stMonth;
        } else{
            //pmt = function(rate_per_period, number_of_payments, present_value, future_value, type){
            var pmtValue = pmt(((formData.interest_rate/100) / 12), loanTerm, formData.loan_value, 0, 0);
            
            rental = Math.abs(pmtValue);
            capitalPayment1stMonth = rental - interest1stMonth;
        }

        $('#installment').val(commaSeparatedNumber(rental.toFixed(2)));
        $('.installment_text').text(commaSeparatedNumber(rental.toFixed(2)));

        $('.load_amount_text').text(commaSeparatedNumber(formData.loan_value.toFixed(2)));
        $('.loan_term_years_text').text(formData.loan_term_years);
        $('.loan_term_months_text').text(formData.loan_term_months);
        $('.interest_rate_text').text(commaSeparatedNumber(formData.interest_rate));
        $('.repayment_method_text').text(formData.repayment_method);

        $('.capital_payment_text').text(commaSeparatedNumber(capitalPayment1stMonth.toFixed(2)));
        $('.interest_payment_text').text(commaSeparatedNumber(interest1stMonth.toFixed(2)));

    };

    // Click Reset Button
    $(document).on('click', '#home-loan-calc-form .btn-reset', function() {
        validator.resetForm();

        $('#installment').val('0.00');
        $('.installment_text').text(0);

        $('.loan_term_years_text').text(0);
        $('.loan_term_months_text').text(0);
        $('.interest_rate_text').text(0);
        $('.repayment_method_text').text('-');

        $('.capital_payment_text').text('0.00');
        $('.interest_payment_text').text('0.00');
    });

    $('#loan_term_years').on('change', function(){
        if(parseInt($(this).val()) === 20){
            $('#loan_term_months').val(0);
            $('#loan_term_months').prop('disabled', 'disabled');
        } else{
            $('#loan_term_months').val('');
            $('#loan_term_months').prop('disabled', false);
        }
    });

    // Click Calculate Button
    $('#home-loan-calc-form').on('submit', function(e) {
        e.preventDefault();
        if ($(this).valid()) {
            var formData = [];
            //formData['loan_value'] = parseFloat(($('#loan_value').cleanVal() / 100).toFixed(2));
            formData['loan_value'] = parseFloat($('#loan_value').cleanVal());
            formData['loan_term_years'] = parseInt($('#loan_term_years').val());
            formData['loan_term_months'] = parseInt($('#loan_term_months').val());
            formData['interest_rate'] = parseFloat($('#interest_rate').val());
            formData['repayment_method'] = $('#repayment_method').val();
            calculate(formData);
        }
    });

}(jQuery));


/*
 * 
 * Cashback Calculator
 *
 */
(function($) {

    // Calculator Validations
    var validator = $('#cashback-calc-form').validate({
        ignore: [],
        rules: {
            loan_value: {
                required: true,
                maxlength: 100
            },
            interest_rate: {
                required: true,
                percentage: true,
                maxlength: 5
            },
        },
        // messages: {},
        errorPlacement: function(error, element) {
            if (element.parent().hasClass('input-group')) {
                element.closest('.input-group').after(error);
            } else if (element.attr('type') === 'checkbox') {
                element.closest('.checkbox').append(error);
            } else {
                error.insertAfter(element);
            }
        },
    });

 // Calculate Function
    var calculate = function(formData) {
        
        var interest = formData.loan_value * (formData.interest_rate/100);

        $('#installment').val(commaSeparatedNumber(interest));
        $('.installment_text').text(commaSeparatedNumber(interest));
        $('.load_amount_text').text(commaSeparatedNumber(formData.loan_value.toFixed(2)));
        $('.interest_rate_text').text(commaSeparatedNumber(formData.interest_rate));
        $('.interest_payment_text').text(commaSeparatedNumber(interest));

    };

    // Click Reset Button
    $(document).on('click', '#cashback-calc-form .btn-reset', function() {
        validator.resetForm();
        $('#installment').val('0.00');
        $('.installment_text').text(0);
        $('.interest_rate_text').text(0);
        $('.interest_payment_text').text('0.00');
    });

    // Click Calculate Button
    $('#cashback-calc-form').on('submit', function(e) {
        e.preventDefault();
        if ($(this).valid()) {
            var formData = [];
            formData['loan_value'] = parseFloat($('#loan_value').cleanVal());
            formData['interest_rate'] = parseFloat($('#interest_rate').val());
            formData['repayment_method'] = $('#repayment_method').val();
            calculate(formData);
        }
    });

}(jQuery));


/*
 * 
 * repayment Calculator
 *
 */
(function($) {

    // Calculator Validations
    var validator = $('#repayment-calc-form').validate({
        ignore: [],
        rules: {
            loan_value: {
                required: true,
                maxlength: 100
            },
            rate_term: {
                required: true,
            },
            repayment_method: {
                required: true,
            },
        },
        // messages: {},
        errorPlacement: function(error, element) {
            if (element.parent().hasClass('input-group')) {
                element.closest('.input-group').after(error);
            } else if (element.attr('type') === 'checkbox') {
                element.closest('.checkbox').append(error);
            } else {
                error.insertAfter(element);
            }
        },
    });

    // Calculate Function
    var calculate = function(formData) {
        var interest = formData.loan_value * (formData.rate_term / 100);

        $('#installment').val(commaSeparatedNumber(interest));
        $('.minimum_payment').text(commaSeparatedNumber(formData.rate_term));
        $('.load_amount_text').text(commaSeparatedNumber(formData.loan_value));
        $('.installment_text').text(commaSeparatedNumber(interest));

    };

    // Click Reset Button
    $(document).on('click', '#repayment-calc-form .btn-reset', function() {
        validator.resetForm();

        $('#installment').val('0.00');
        $('.load_amount_text').text(0);

        $('.minimum_payment').text(0); 
        $('.installment_text').text(0);

    });

    // Click Calculate Button
    $('#repayment-calc-form').on('submit', function(e) {
        e.preventDefault();
        if ($(this).valid()) {
            var formData = [];
            formData['loan_value'] = parseFloat($('#loan_value').cleanVal());
            formData['rate_term'] = $('#rate_term').val();
            calculate(formData);
        }
    });

}(jQuery));
